<template>
    <div v-if="visible" :style="{height: height + 'px'}">
        <section ref="bar" class="request-changes-bar argus-glass-dialog"
            :class="{'request-changes-bar--attention': dirty}" :style="position" :aria-label="label">
            <div class="request-changes-bar__row">
                <div class="request-changes-bar__summary" aria-live="polite">
                    <strong>{{ dirty ? 'Есть несохранённые изменения' : success ? 'Изменения сохранены' : checkLabel }}</strong>
                    <div v-if="dirty" class="small">{{ summary.join(' · ') }}</div>
                </div>
                <div class="request-changes-bar__buttons">
                    <b-button v-if="dirty" variant="outline-secondary" size="sm" :disabled="busy" @click="$emit('discard')">Отменить изменения</b-button>
                    <b-button v-if="dirty" variant="success" size="sm" :disabled="busy" @click="$emit('save')">
                        <b-spinner v-if="busy" small class="mr-1" />{{ busy ? 'Подождите…' : 'Сохранить изменения' }}
                    </b-button>
                    <b-button v-else-if="!error" variant="outline-secondary" size="sm" aria-label="Закрыть сообщение о сохранении" @click="$emit('dismiss')">Закрыть</b-button>
                </div>
            </div>
            <div v-if="error" role="alert" class="alert alert-danger mb-0 mt-2">{{ error }}</div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        label: {type: String, default: 'Сохранение изменений заявки'},
        checkLabel: {type: String, default: 'Проверьте заявку'},
        dirty: Boolean, busy: Boolean, error: {type: String, default: ''}, success: Boolean,
        summary: {type: Array, default: () => []}
    },
    data: () => ({height: 0, position: {}}),
    computed: {visible() { return this.dirty || this.error || this.success; }},
    watch: {visible() { this.$nextTick(this.measure); }},
    mounted() {
        this.observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(this.measure);
        if (this.observer) {
            this.observer.observe(this.$el.parentElement);
            const nav = document.querySelector('.modern-shell__bottom-nav');
            if (nav) this.observer.observe(nav);
        }
        window.addEventListener('resize', this.measure);
        this.$nextTick(this.measure);
    },
    updated() { this.measure(); },
    beforeDestroy() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.measure);
    },
    methods: {
        measure() {
            if (!this.$refs.bar || !this.$el.parentElement) return;
            const bounds = this.$el.parentElement.getBoundingClientRect();
            const nav = document.querySelector('.modern-shell__bottom-nav');
            const navBounds = nav && nav.getBoundingClientRect();
            const bottom = navBounds && navBounds.height && navBounds.top < window.innerHeight
                ? Math.max(0, window.innerHeight - navBounds.top) + 8 : 8;
            const left = Math.max(8, bounds.left);
            const width = Math.max(0, Math.min(window.innerWidth - 8, bounds.right) - left);
            const position = {left: left + 'px', width: width + 'px', bottom: bottom + 'px'};
            if (JSON.stringify(position) !== JSON.stringify(this.position)) this.position = position;
            this.height = this.$refs.bar.offsetHeight + bottom + 8;
        }
    }
};
</script>

<style scoped>
.request-changes-bar {
    position: fixed; z-index: 1025; padding: 12px 16px;
    background: var(--argus-glass-solid, #f8fafc); border: 1px solid #b6d6c8; border-radius: 12px;
    box-shadow: var(--argus-glass-dialog-shadow, 0 4px 24px rgba(23, 65, 51, .14));
    padding-bottom: max(12px, env(safe-area-inset-bottom));
}
.request-changes-bar__row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.request-changes-bar__summary { min-width: 0; overflow-wrap: anywhere; }
.request-changes-bar__buttons { display: flex; gap: 8px; flex-shrink: 0; }
.request-changes-bar--attention { animation: request-changes-attention 750ms ease-in-out 4; }
@keyframes request-changes-attention {
    0%, 100% {
        background: var(--argus-glass-solid, #f8fafc);
        border-color: #b6d6c8;
        box-shadow: var(--argus-glass-dialog-shadow, 0 4px 24px rgba(23, 65, 51, .14));
    }
    45%, 60% {
        background: #ffe08a;
        border-color: #d58b00;
        box-shadow: 0 0 0 5px rgba(255, 181, 28, .55), 0 6px 28px rgba(172, 111, 0, .3);
    }
}
@media (prefers-reduced-motion: reduce) {
    .request-changes-bar--attention { animation: none; background: #fff3cd; border-color: #d58b00; }
}
.alert { overflow-wrap: anywhere; max-height: 30vh; overflow-y: auto; }
@media (max-width: 575px) {
    .request-changes-bar { padding: 10px; }
    .request-changes-bar__row { flex-direction: column; align-items: stretch; gap: 8px; }
    .request-changes-bar__buttons { flex-wrap: wrap; }
    .request-changes-bar__buttons .btn { flex: 1; }
}
</style>
